import React from "react";
import { Modal } from "@mui/material";
import UploadFileForModal from "./UploadFileForModal";
import { StyledModal } from "../doctor-console/StyledComponents";

const UploadFileModal = ({
  isOpen,
  handleClose,
  abhaId,
  patientId,
  onUploadSuccess,
}) => {
  return (
    // <Modal open={isOpen} onClose={handleClose} style={{ overflowY: "auto" }}>
    //   <div className="modal-container">
    //     <UploadFileForModal abhaId={abhaId} patientId={patientId} handleClose={handleClose} />
    //   </div>
    // </Modal>
    <StyledModal open={isOpen} handleClose={handleClose} title="Upload Report">
      <UploadFileForModal
        abhaId={abhaId}
        patientId={patientId}
        handleClose={handleClose}
        onUploadSuccess={onUploadSuccess}
      />
    </StyledModal>
  );
};

export default UploadFileModal;
